// extracted by css-extract-rspack-plugin
export default {"chartList":"Index-module__chartList__ffQhgMg","chartListItem":"Index-module__chartListItem__miwwGRW","titleContainer":"Index-module__titleContainer__sdt_4V4"};